import { PlusOutlined } from '@ant-design/icons';
import { Handle, type HandleProps, Position } from '@xyflow/react';
import { canAddNodesSelector } from 'automations/selectors/reactFlow';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import styles from './NodeHandler.module.scss';

/**
 * Node Handle - Custom Handle used for creating & showing connections between nodes
 * @param HandleProps - ReactFlow Handle Props
 * @param iconClassName - Class name for the icon
 * @param iconProps - Props for the icon
 * @returns {JSX.Element}
 */
export default function NodeHandler({
  type,
  position,
  className,
  iconClassName,
  iconProps,
  onClick,
  nodeId,
  ...rest
}: HandleProps & {
  nodeId: string;
  iconClassName?: string;
  iconProps?: React.ComponentProps<typeof PlusOutlined>;
}) {
  const canAddNodes = useSelector(canAddNodesSelector(nodeId));

  if (position === Position.Top || !canAddNodes) {
    return (
      <Handle
        type={type}
        position={position}
        className={clsx(
          styles.customHandle,
          position === Position.Top && styles.small,
          className,
        )}
        {...rest}
      />
    );
  } else {
    return (
      <Handle
        type={type}
        position={position}
        className={clsx(styles.customHandle, className)}
        onClick={onClick}
        {...rest}
      >
        <PlusOutlined
          className={clsx(styles.handleIcon, iconClassName)}
          {...iconProps}
        />
      </Handle>
    );
  }
}
